import HomeAd from 'assets/anim/status.json';
import BoxIcon from "assets/img/icons/box.png";
import ProgressIcon from "assets/img/icons/progress.png";
import Widget from "components/widget/Widget";
import SearchField from "components/fields/SearchField";
import Lottie from "lottie-react";
import StatusChart from "views/home/components/StatusChart";
import { BiSolidNotepad } from "react-icons/bi";
import { BsFillClockFill } from "react-icons/bs";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";

const Status = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container">
          <div className="w-full flex items-center px-2.5 md:px-3 lg:px-5 py-6">
            <div className="md:flex justify-between w-full md:py-6">
              <p className="relative text-header text-white md:mb-0 mb-4">Network Status</p>
              <SearchField
                extra="sm:min-w-[480px] xl:min-w-[650px]"
                placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                id="email"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-3 xl:px-5 grid grid-cols-1 xl:grid-cols-3 gap-6">
          <div className="lg:px-[64px] bg-white dark:border-darkPrimary dark:!bg-darkPrimary box overflow-hidden lg:col-span-2 flex items-center gap-2">
            <div className="grow grid grid-cols-1 md:grid-cols-2 gap-1 px-2.5 md:px-5 pt-5 lg:pb-5">
                <Widget
                icon={<img
                    className="w-7 h-7"
                    src={BoxIcon}
                    alt=""
                />}
                title={"Latest Block"}
                subtitle={<span className="text-green-900">125,356,564</span>}
                />
                <Widget
                icon={<BsFillClockFill className="h-7 w-7" />}
                title={"Average Block Time"}
                subtitle={<span>12.5 Seconds</span>}
                />
                <Widget
                icon={<BiSolidNotepad className="h-7 w-7" />}
                title={"Transaction Throughput"}
                subtitle={<span><span className="text-green-900 mr-1">20 Txn</span>per sec</span>}
                border="border-b-[1px] lg:border-none"
                />
                <Widget
                icon={<img
                    className="w-7 h-7"
                    src={ProgressIcon}
                    alt=""
                />}
                title={"Network Hash Rate"}
                subtitle={<span>120 TH/s</span>}
                border="border-none"
                />
                <div className="flex lg:hidden h-full justify-center mt-[-1.25rem]">
                  <Lottie 
                    animationData={HomeAd} 
                    loop={true} 
                    style={{ width: '205px', height: '205px' }} 
                  />
                </div>
            </div>
            <div className="hidden lg:flex lg:col-span-4 h-full justify-center">
              <Lottie 
                animationData={HomeAd} 
                loop={true} 
                style={{ width: '205px', height: '205px' }} 
              />
            </div>
          </div>
          <div className="box overflow-hidden">
            <StatusChart />
          </div>
        </div>
        <div className="mt-6 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex flex-col mt-5">
              <div className="flex gap-1 flex-row items-center justify-between flex-wrap w-full px-2.5 md:px-5 py-4">
                <div className="not-italic text-large">
                More than 280,993 Blocks Found
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="">
                    <th className="">Block</th>
                    <th className="">Avg. Block  Time</th>
                    <th className="">Transaction Throughput</th>
                    <th className="">Network Hash Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(10).fill(0).map((data) => <tr>
                      <td>
                        <p className="text-green-900 text-small">109,901,461</p>
                        <p className="text-gray-700 text-xsmall">125 sec ago</p>
                      </td>
                      <td>
                        <p className="text-small">12.5 Sec</p>
                      </td>
                      <td>
                        <span><span className="text-small text-green-900 mr-1">20 Txn</span>per sec</span>
                      </td>
                      <td>
                        <span className="text-small">120 TH/s</span>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="p-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Status;
